import { FORMAT_TYPE } from "../../data/variables"
import i18n from "../../i18n"
import { deleteFleet, getFleets } from "../../services/calls/fleet"
import { getSystemMobiles } from "../../services/calls/mobiles"
import { deleteSensorTemperatureSettings, getSensorTemperatureSettings, getSensorTemperatureSettingsContacts } from "../../services/calls/sensors"
import { deleteSystemUser, getSystemUsers } from "../../services/calls/users"
import { isValidEmail } from "../../services/utils/validation"
import { saveFleet, saveMobile, saveSystemUser, saveTemperatureSettings } from "./utils"

export enum MANAGEMENT_DATA_IDS {
  IMAGE = 'IMAGE',
  REGISTRY_NUMBER = 'REGISTRY_NUMBER',
  GLOBAL_ID = 'GLOBAL_ID',
  MOBILE_DESCR = 'MOBILE_DESCR',
  FLEET_ACCESS = 'FLEET_ACCESS',
  KM_USAGE = 'KM_USAGE',
  HRS_USAGE = 'HRS_USAGE',
  FLEET_NAME = 'FLEET_NAME',
  FLEET_DESCR = 'FLEET_DESCR',
  FLEET_ICON = 'FLEET_ICON',
  FLEET_CARS = 'FLEET_CARS',
  SENSOR_NUMBER = 'SENSOR_NUMBER',
  SENSOR = 'SENSOR',
  SENSOR_DESCR = 'SENSOR_DESCR',
  UPPER_LIMIT = 'UPPER_LIMIT',
  LOWER_LIMIT = 'LOWER_LIMIT',
  TIME_LIMIT = 'TIME_LIMIT',
  CONTACTS = 'CONTACTS',
  EMAIL = 'EMAIL',
  TEXT_NOTIFICATION = 'TEXT_NOTIFICATION',
  USERNAME = 'USERNAME',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  USER_EMAIL = 'USER_EMAIL',
  PERMISSION_FLEET = 'PERMISSION_FLEET',
  SEND_USER_LOGIN = 'SEND_USER_LOGIN',
  CUSTOM_ICON = 'CUSTOM_ICON',
  FILE_UPLOAD = 'FILE_UPLOAD',
  SENSOR_MOBILE = 'SENSOR_MOBILE'
}

const DATA = {
  [MANAGEMENT_DATA_IDS.IMAGE]: {
    id: MANAGEMENT_DATA_IDS.IMAGE,
    label: i18n.t('Picture'),
    path: 'picture',
    type: 'img',
    onlyInTable: true,
    width: '80px'
  },
  [MANAGEMENT_DATA_IDS.REGISTRY_NUMBER]: {
    id: MANAGEMENT_DATA_IDS.REGISTRY_NUMBER,
    label: i18n.t('Registry number'),
    path: 'registration_number',
    type: 'text',
    readonly: (data: any) => !!data.id,
    width: '250px'
  },
  [MANAGEMENT_DATA_IDS.GLOBAL_ID]: {
    id: MANAGEMENT_DATA_IDS.GLOBAL_ID,
    label: i18n.t('Global ID'),
    path: 'globalid',
    type: 'text',
    text: i18n.t('Name of the mobile')
  },
  [MANAGEMENT_DATA_IDS.MOBILE_DESCR]: {
    id: MANAGEMENT_DATA_IDS.MOBILE_DESCR,
    label: i18n.t('Description'),
    path: 'description',
    type: 'text'
  },
  [MANAGEMENT_DATA_IDS.FLEET_ACCESS]: {
    id: MANAGEMENT_DATA_IDS.FLEET_ACCESS,
    label: i18n.t('Fleet access'),
    header: i18n.t('Fleet access'),
    path: 'all_fleets',
    type: 'tag',
    options: 'fleets',
    text: i18n.t('Select fleets you would like to add this car to'),
    width: { min: '300px', max: '500px'}
  },
  [MANAGEMENT_DATA_IDS.KM_USAGE]: {
    id: MANAGEMENT_DATA_IDS.KM_USAGE,
    label: i18n.t('Usage (km)'),
    path: 'odometer',
    decimal: 0,
    type: 'number',
    format: FORMAT_TYPE.KILOMETERS
  },
  [MANAGEMENT_DATA_IDS.HRS_USAGE]: {
    id: MANAGEMENT_DATA_IDS.HRS_USAGE,
    label: i18n.t('Usage (hrs)'),
    path: 'engineruntime',
    type: 'number',
    format: FORMAT_TYPE.HOURS
  },
  [MANAGEMENT_DATA_IDS.FLEET_NAME]: {
    id: MANAGEMENT_DATA_IDS.FLEET_NAME,
    label: i18n.t('Name'),
    path: 'name',
    type: 'text',
    text: i18n.t('Give a name to the fleet'),
    width: '250px'
  },
  [MANAGEMENT_DATA_IDS.FLEET_DESCR]: {
    id: MANAGEMENT_DATA_IDS.FLEET_DESCR,
    label: i18n.t('Description'),
    path: 'description',
    type: 'text',
    text: i18n.t('Give a description to the fleet'),
    width: '300px'
  },
  [MANAGEMENT_DATA_IDS.FLEET_ICON]: {
    id: MANAGEMENT_DATA_IDS.FLEET_ICON,
    label: i18n.t('Icon'),
    inputLabel: i18n.t('Icon for cars in this fleet'),
    path: 'icon',
    type: 'icons',
    text: i18n.t('All the cars in this fleet will be shown with the selected icon on the map')
  },
  [MANAGEMENT_DATA_IDS.FLEET_CARS]: {
    id: MANAGEMENT_DATA_IDS.FLEET_CARS,
    label: i18n.t('Cars in this fleet'),
    inputLabel: i18n.t('Add a car to this fleet'),
    header: i18n.t('Cars added in this fleet'),
    path: 'mobiles',
    arrayKey: 'id',
    type: 'tag',
    text: i18n.t('Select a car you would like to add to this fleet'),
    options: 'cars'
  },
  [MANAGEMENT_DATA_IDS.SENSOR_NUMBER]: {
    id: MANAGEMENT_DATA_IDS.SENSOR_NUMBER,
    label: i18n.t('Registration number'),
    path: 'mobile_globalid',
    type: 'select',
    options: 'cars',
    onlyInTable: true,
    width: '250px'
  },
  [MANAGEMENT_DATA_IDS.SENSOR_MOBILE]: {
    id: MANAGEMENT_DATA_IDS.SENSOR_MOBILE,
    label: i18n.t('Registration number'),
    path: 'mobile_id',
    type: 'select',
    options: 'cars',
    onlyInForm: true,
    readonly: (data: any) => !!data.sensor_id
  },
  [MANAGEMENT_DATA_IDS.SENSOR]: {
    id: MANAGEMENT_DATA_IDS.SENSOR,
    label: i18n.t('Sensor'),
    path: 'sensor',
    type: 'select',
    options: 'sensors',
    visible: (data: any) => data.mobile_id,
    onlyInForm: true,
    readonly: (data: any) => !!data.sensor_id
  },
  [MANAGEMENT_DATA_IDS.SENSOR_DESCR]: {
    id: MANAGEMENT_DATA_IDS.SENSOR_DESCR,
    label: i18n.t('Sensor'),
    path: 'sensor_description',
    type: 'select',
    options: 'sensors',
    onlyInTable: true,
  },
  [MANAGEMENT_DATA_IDS.UPPER_LIMIT]: {
    id: MANAGEMENT_DATA_IDS.UPPER_LIMIT,
    label: i18n.t('Upper limit (˚C)'),
    path: 'upper_limit',
    type: 'number',
  },
  [MANAGEMENT_DATA_IDS.LOWER_LIMIT]: {
    id: MANAGEMENT_DATA_IDS.LOWER_LIMIT,
    label: i18n.t('Lower limit (˚C)'),
    path: 'lower_limit',
    type: 'number',
  },
  [MANAGEMENT_DATA_IDS.TIME_LIMIT]: {
    id: MANAGEMENT_DATA_IDS.TIME_LIMIT,
    label: i18n.t('Time limit (minutes)'),
    path: 'time_tolerance',
    type: 'number',
    text: i18n.t('When the temperature has been out of the range specified for this time limit, you will receive a notification to the contact you input below.')
  },
  [MANAGEMENT_DATA_IDS.CONTACTS]: {
    id: MANAGEMENT_DATA_IDS.CONTACTS,
    label: i18n.t('Contacts'),
    path: 'contacts',
    type: 'text',
    onlyInTable: true,
    width: { min: '250px', max: '400px' }
  },
  [MANAGEMENT_DATA_IDS.EMAIL]: {
    id: MANAGEMENT_DATA_IDS.EMAIL,
    label: i18n.t('E-mail'),
    header: i18n.t('Emails added to sensor setting'),
    buttonLabel: i18n.t('Add email'),
    path: 'emails',
    onlyInForm: true,
    type: 'tag-text'
  },
  [MANAGEMENT_DATA_IDS.TEXT_NOTIFICATION]: {
    id: MANAGEMENT_DATA_IDS.TEXT_NOTIFICATION,
    label: i18n.t('Text notification'),
    header: i18n.t('Text notifications added to sensor setting'),
    buttonLabel: i18n.t('Add text notification'),
    path: 'sms',
    onlyInForm: true,
    type: 'tag-text'
  },
  [MANAGEMENT_DATA_IDS.USERNAME]: {
    id: MANAGEMENT_DATA_IDS.USERNAME,
    label: (data: any) => !data.id ? i18n.t('Email address / username') : i18n.t('Username'),
    path: 'username',
    type: 'text',
    text: (data: any) => {
      if (data.id) {
        if (data.username !== data.user_context.username) return i18n.t('Only the user can change their own email address.')
        else return null
      }
      return i18n.t('This is going to be the username they will need to use to login into the system')
    },
    readonly: (data: any) => data.id && data.original.username !== data.user_context.username,
    width: '250px'
  },
  [MANAGEMENT_DATA_IDS.FIRST_NAME]: {
    id: MANAGEMENT_DATA_IDS.FIRST_NAME,
    label: i18n.t('First name'),
    path: 'first_name',
    type: 'text'
  },
  [MANAGEMENT_DATA_IDS.LAST_NAME]: {
    id: MANAGEMENT_DATA_IDS.LAST_NAME,
    label: i18n.t('Last name'),
    path: 'last_name',
    type: 'text'
  },
  [MANAGEMENT_DATA_IDS.USER_EMAIL]: {
    id: MANAGEMENT_DATA_IDS.USER_EMAIL,
    label: i18n.t('E-mail'),
    path: 'email',
    type: 'text',
    visible: (data: any) => !!data.id && !isValidEmail(data.username),
    width: '250px'
  },
  [MANAGEMENT_DATA_IDS.PERMISSION_FLEET]: {
    id: MANAGEMENT_DATA_IDS.PERMISSION_FLEET,
    label: i18n.t('Permission on fleet'),
    header: i18n.t('User has permission on the following fleet'),
    path: 'fleets',
    arrayKey: 'fleetid',
    type: 'tag',
    options: 'fleets',
    text: i18n.t('Set which fleet this user is allowed to see.'),
    width: { min: '250px', max: '400px' }
  },
  [MANAGEMENT_DATA_IDS.SEND_USER_LOGIN]: {
    id: MANAGEMENT_DATA_IDS.SEND_USER_LOGIN,
    label: i18n.t('Send the user an email with their login information.'),
    path: 'send_email',
    type: 'checkbox',
    onlyInForm: true,
    visible: (data: any) => !!!data.id
  },
  [MANAGEMENT_DATA_IDS.CUSTOM_ICON]: {
    id: MANAGEMENT_DATA_IDS.CUSTOM_ICON,
    label: i18n.t('Icon'),
    path: 'cust_icon',
    type: 'icons',
    text: i18n.t('The mobile will be shown with the selected icon on the map'),
    width: '200px'
  },
  [MANAGEMENT_DATA_IDS.FILE_UPLOAD]: {
    id: MANAGEMENT_DATA_IDS.FILE_UPLOAD,
    label: (data: any) => `${i18n.t('Add a picture for the mobile')} ${data?.registration_number}`,
    path: 'picture',
    type: 'file',
    onlyInForm: true,
    maxFiles: 5,
    allowedFiles: 'image'
  }
}

export const MANAGEMENT_VIEWS = {
  mobiles: {
    label: i18n.t('Manage mobiles'),
    item: i18n.t('mobile'),
    mainRow: MANAGEMENT_DATA_IDS.REGISTRY_NUMBER,
    canAddNew: false,
    addNewLabel: i18n.t('Add a new mobile'),
    idKey: 'id',
    isDeletable: () => false,
    hasModalPhoto: true,
    photoPath: 'picture',
    getFunction: () => getSystemMobiles({}),
    saveFunction: (data: any, id: number, oldData: any) => saveMobile(data, id, oldData),
    rowHeight: 87,
    default_sort: DATA.REGISTRY_NUMBER.id,
    data: [
      DATA.IMAGE, DATA.REGISTRY_NUMBER, DATA.GLOBAL_ID, DATA.CUSTOM_ICON, DATA.MOBILE_DESCR,
      DATA.FLEET_ACCESS, DATA.KM_USAGE, DATA.HRS_USAGE, DATA.FILE_UPLOAD
    ]
  },
  fleet: {
    label: i18n.t('Manage fleet'),
    item: i18n.t('fleet'),
    mainRow: MANAGEMENT_DATA_IDS.FLEET_NAME,
    canAddNew: true,
    addNewLabel: i18n.t('Add new fleet'),
    idKey: 'fleetid',
    isDeletable: (data: any) => !data.main_fleet,
    getFunction: () => getFleets(),
    deleteFunction: (id: number) => deleteFleet(id),
    saveFunction: (data: any, id: number, oldData: any) => saveFleet(data, id, oldData),
    default_sort: DATA.FLEET_NAME.id,
    data: [
      DATA.FLEET_NAME, DATA.FLEET_DESCR, DATA.FLEET_CARS
    ]
  },
  users: {
    label: i18n.t('Manage users'),
    item: i18n.t('user'),
    mainRow: MANAGEMENT_DATA_IDS.USERNAME,
    canAddNew: true,
    addNewLabel: i18n.t('Add user'),
    idKey: 'id',
    isDeletable: () => true,
    getFunction: () => getSystemUsers(),
    deleteFunction: (id: number) => deleteSystemUser(id),
    saveFunction: (data: any, id: number, oldData: any) => saveSystemUser(data, id, oldData),
    default_sort: DATA.USERNAME.id,
    data: [
      DATA.USERNAME, DATA.SEND_USER_LOGIN, DATA.FIRST_NAME, DATA.LAST_NAME, DATA.USER_EMAIL, DATA.PERMISSION_FLEET
    ]
  },
  sensors: {
    label: i18n.t('Sensor temperature settings'),
    item: i18n.t('sensor setting'),
    mainRow: MANAGEMENT_DATA_IDS.SENSOR_NUMBER,
    canAddNew: true,
    addNewLabel: i18n.t('Add sensor settings'),
    idKey: 'id',
    isDeletable: () => true,
    getFunction: async () => {
      const sensorSettings = await getSensorTemperatureSettings()
      const contacts = await getSensorTemperatureSettingsContacts()

      const contactMap = contacts.reduce((obj, contact) => {
        if (!obj[contact.temperature_settings]) obj[contact.temperature_settings] = { contacts: [], emails:[], sms: []}
        if (contact.email) {
          obj[contact.temperature_settings].contacts.push(contact.email)
          obj[contact.temperature_settings].emails.push(contact.email)
        }
        if (contact.sms) {
          obj[contact.temperature_settings].contacts.push(contact.sms)
          obj[contact.temperature_settings].sms.push(contact.sms)
        }
        return obj
      }, {})

      return sensorSettings.map((sensor) => ({
        ...sensor,
        contacts: contactMap[sensor.id]?.contacts,
        emails: contactMap[sensor.id]?.emails,
        sms: contactMap[sensor.id]?.sms,
        contactMap: contacts
      }))
    },
    deleteFunction: (id: number) => deleteSensorTemperatureSettings(id),
    saveFunction: (data: any, id: number) => saveTemperatureSettings(data, id),
    default_sort: DATA.SENSOR_NUMBER.id,
    data: [
      DATA.SENSOR_NUMBER, DATA.SENSOR_MOBILE, DATA.SENSOR_DESCR, DATA.SENSOR, DATA.UPPER_LIMIT, DATA.LOWER_LIMIT,
      DATA.TIME_LIMIT, DATA.CONTACTS, DATA.EMAIL, DATA.TEXT_NOTIFICATION
    ],
    watchKeys: [DATA.SENSOR_MOBILE]
  }
}
